import { Controller } from "stimulus"
import Swal from "sweetalert2";

export default class extends Controller {
  static values = {
    message: String
  }

  connect() {
    if (!this.hasMessageValue)
      return this.destroyFrame();

    Swal.fire('Pronto', this.messageValue, 'success').then(() => {
      this.destroyFrame();
    });
  }

  destroyFrame() {
    let turboFrame = this.element.closest('turbo-frame');
    !!turboFrame && turboFrame.remove();
  }
}